export const steps = [
  {
    title: '1° passo',
    description: 'Faça o seu cadastro no ENEMVERSO, aceite a missão e receba sua chave de acesso ao jogo.'
  },
  {
    title: '2° passo',
    description: 'Entre no Fortnite no modo criativo e adicione a chave de acesso para entrar no mapa Expedição ENEMVERSO.'
  },
  {
    title: '3° passo',
    description: 'Resolva os puzzles dos 5 mapas de conhecimento e descubra o código secreto da semana.'
  },
  {
    title: '4° passo',
    description: 'Use o código secreto para resgatar o número da sorte para o sorteio das bolsas de graduação.'
  }
]